import { ReactNode } from 'react'

export function SettingsHeading({ children }: { children: ReactNode }) {
	return <h1 className="text-4xl font-light mt-10 tracking-tight">{children}</h1>
}

export function SettingsSubheading({ children }: { children: ReactNode }) {
	return <h2 className="text-2xl font-medium mt-10 tracking-tight">{children}</h2>
}
